export const environment = {
  production: false,
  apiUrl: 'https://reservelt-test.com/api'
};
